<script>
	import { onMount } from "svelte";
	import { fade } from "svelte/transition";
	import { Route } from "svelte-router-spa";
	import { navigateTo } from "svelte-router-spa";
	import { _, locale, getLocaleFromNavigator } from "svelte-i18n";
	import Cookies from "js-cookie";
	import Select from "svelte-select";
	import { isDarkMode } from "./store/theme-store.js";
	import { accessToken } from "./store/auth-store";

	export let currentRoute;
	export let params = {};

	const LOGO_URL =
		"https://groovworks-avatalk-public-file-storage.s3.ap-northeast-2.amazonaws.com/common/index-images/index_navLogo.png";

	let activeLink;
	let scrolled = false;
	let menuOpen = false;

	const closeMenu = () => { menuOpen = false; };
	const handleMenuLinkClick = (link) => {
		closeMenu();
		handleLinkClick(link);
	};
	const supportedLanguages = ["ko", "en", "jp"];
	const langs = [
		{ value: "ko", label: "한국어" },
		{ value: "en", label: "English" },
		{ value: "ja", label: "日本語" },
	];
	let lang = "ko";

	onMount(() => {
		let urlSearchLang = new URLSearchParams(window.location.search).get(
			"lang",
		);
		if (urlSearchLang) {
			if (supportedLanguages.includes(urlSearchLang)) {
				if (urlSearchLang === "jp") {
					urlSearchLang = "ja";
				}
				Cookies.set("lang", urlSearchLang, { expires: 365 });
				locale.set(urlSearchLang);
				lang = urlSearchLang;
				return;
			}
		}
		lang = Cookies.get("lang") || getLocaleFromNavigator().substring(0, 2);
		activeLink = window.location.pathname;
		isDarkMode.update(() => window.location.pathname === "/character-chat");

		const onScroll = () => {
			scrolled = window.scrollY > 10;
		};
		window.addEventListener("scroll", onScroll, { passive: true });
		return () => window.removeEventListener("scroll", onScroll);
	});
	const clickLogo = () => {
		location.href = "https://www.groovworks.com/";
	};

	const changeLanguage = (event) => {
		const newLang = event.detail.value;
		locale.set(newLang);
		Cookies.set("lang", newLang, { expires: 365 });
	};

	const handleLinkClick = (link) => {
		if (link == "/character-chat") {
			isDarkMode.update(() => true);
		} else {
			isDarkMode.update(() => false);
		}
		activeLink = link;
		navigateTo(link);
	};
</script>

<div class="wrap" in:fade id="index-layout" class:dark-mode={$isDarkMode}>
	<div class="nav-wrap">
		<nav class="idx-nav" class:scrolled class:dark={$isDarkMode}>
			<div class="nav-inner">
				<div class="nav-left">
					<img
						src={LOGO_URL}
						alt="AVATALK"
						class="nav-logo"
						on:click={() => handleLinkClick("/")}
						style="cursor:pointer"
					/>
					<div class="nav-links">
						<a
							href="#"
							class="nl {activeLink === '/character-chat'
								? 'nl-active'
								: ''}"
							on:click|preventDefault={() =>
								handleLinkClick("/character-chat")}
							>{$_("project.index.0_characterchat")}</a
						>
						<a
							href="#"
							class="nl {activeLink === '/event'
								? 'nl-active'
								: ''}"
							on:click|preventDefault={() =>
								handleLinkClick("/event")}
							>{$_("project.index.0_eventTitle")}</a
						>
						<a
							href="#"
							class="nl {activeLink === '/usecase'
								? 'nl-active'
								: ''}"
							on:click|preventDefault={() =>
								handleLinkClick("/usecase")}
							>{$_("project.index.1_example")}</a
						>
						<a
							href="#"
							class="nl {activeLink === '/pricing'
								? 'nl-active'
								: ''}"
							on:click|preventDefault={() =>
								handleLinkClick("/pricing")}
							>{$_("project.builder.14")}</a
						>
						<a
							href="https://www.groovworks.com/contactus"
							target="_blank"
							rel="noopener noreferrer"
							class="nl">문의하기</a
						>
					</div>
				</div>
				<div class="nav-right">
					<!-- <div class="language-sel">
						<Select
							items={langs}
							value={lang}
							on:select={changeLanguage}
							clearable={false}
							showChevron
							--font-size="13px"
							containerStyles="display:flex"
						/>
					</div> -->
					{#if !$accessToken}
						<button
							class="btn-login desktop-only"
							on:click={() => handleLinkClick("/login")}
							>{$_("project.index.3")}</button
						>
						<button
							class="btn-start desktop-only"
							on:click={() => handleLinkClick("/join")}
							>{$_("project.index.4_freeTitle")}</button
						>
					{:else}
						<div
							class="home-icon pointer desktop-only"
							on:click={() => handleLinkClick("/main")}
							aria-label="홈"
						>
							<svg
								viewBox="0 0 24 24"
								fill="none"
								stroke="currentColor"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							>
								<path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
								<polyline points="9 22 9 12 15 12 15 22" />
							</svg>
						</div>
					{/if}
					<button
						class="hamburger"
						class:open={menuOpen}
						on:click={() => (menuOpen = !menuOpen)}
						aria-label="메뉴"
					>
						<span></span>
						<span></span>
						<span></span>
					</button>
				</div>
			</div>
		</nav>

		{#if menuOpen}
			<div class="mobile-menu" class:dark={$isDarkMode}>
				<a href="#" class="mm-link" class:mm-active={activeLink === '/character-chat'} on:click|preventDefault={() => handleMenuLinkClick("/character-chat")}>{$_("project.index.0_characterchat")}</a>
				<a href="#" class="mm-link" class:mm-active={activeLink === '/event'} on:click|preventDefault={() => handleMenuLinkClick("/event")}>{$_("project.index.0_eventTitle")}</a>
				<a href="#" class="mm-link" class:mm-active={activeLink === '/usecase'} on:click|preventDefault={() => handleMenuLinkClick("/usecase")}>{$_("project.index.1_example")}</a>
				<a href="#" class="mm-link" class:mm-active={activeLink === '/pricing'} on:click|preventDefault={() => handleMenuLinkClick("/pricing")}>{$_("project.builder.14")}</a>
				<a href="https://www.groovworks.com/contactus" target="_blank" rel="noopener noreferrer" class="mm-link" on:click={closeMenu}>문의하기</a>
				<div class="mm-divider"></div>
				{#if !$accessToken}
					<button class="mm-btn-login" on:click={() => handleMenuLinkClick("/login")}>{$_("project.index.3")}</button>
					<button class="mm-btn-start" on:click={() => handleMenuLinkClick("/join")}>{$_("project.index.4_freeTitle")}</button>
				{:else}
					<button class="mm-btn-start" on:click={() => handleMenuLinkClick("/main")}>홈으로</button>
				{/if}
			</div>
		{/if}
	</div>
	<Route {currentRoute} {params} />
	<div class="section-footer avatalk wf-section">
		<div class="footer-wrap">
			<div class="footer-logo">
				<div class="div-block-17">
					<a href="#" class="brand w-nav-brand" on:click={clickLogo}
						><img
							src="/static/images/top_logo.svg"
							alt="logo"
							class="image-15"
						/></a
					>
					<div class="sns">
						<a
							href="https://www.instagram.com/groovworks.official/"
							target="_blank"
							class="g-instalink w-inline-block"
							><img
								src="/static/images/insta.png"
								loading="lazy"
								width="36"
								alt=""
								class="g-insta"
							/></a
						>
						<a
							href="https://www.facebook.com/groovworks"
							target="_blank"
							class="g-facebooklink w-inline-block"
							><img
								src="/static/images/facebook.png"
								loading="lazy"
								width="36"
								alt=""
								class="g-facebook"
							/></a
						>
						<a
							href="https://www.youtube.com/channel/UC3R6fO21OkUJcdLSRy6Az4g"
							target="_blank"
							class="g-youtubelink w-inline-block"
							><img
								src="/static/images/youtube.png"
								loading="lazy"
								width="36"
								alt=""
								class="g-youtube"
							/></a
						>
					</div>
				</div>
			</div>

			<div class="footer_con">
				{#if $_("project.index.0") == "ko"}
					<div class="text-block-15">
						그루브웍스 주식회사 | 대표이사 : 김창겸 |
						avatalk@groovworks.com | Tel : 02-6673-3840<br />
					</div>
					<div class="text-block-15">
						<span class="text-span-24">본사</span><strong>
						</strong>서울시 강남구 영동대로 602, 6층 C234호
					</div>
					<div class="text-block-15">
						<span class="text-span-24">연구소</span> 서울 강남구 도곡동
						955-12, 3층
					</div>
					<div class="text-block-15">
						<span class="text-span-24"
							>사업자등록번호: 433-86-01784 | 통신판매업신고번호:
							제 2021-서울강남-02072 호</span
						>
					</div>
				{:else if $_("project.index.0") == "ja"}
					<div class="text-block-15">
						問い合わせ : avatalk@groovworks.com<br />
					</div>
					<!-- <div class="footer_con_term">
                    <p class="paragraph-15-avatalk">
                        <a href="https://phantom-cap-f7c.notion.site/d58aaaedee164364a7a74eb98181d036" target="_blank" class="link-19 avatalk">サービス利用約款</a> | 
                        <a href="https://phantom-cap-f7c.notion.site/7ccdf3b4e75b412a89a76a3daaa76509" target="_blank" class="link-19 avatalk">個人情報処理方針</a> | 
                        <a href="https://phantom-cap-f7c.notion.site/36d49e46c40d4566aa868f710990bb57" target="_blank" class="link-19 avatalk">マーケティング情報活用同意</a>
                    </p>
                </div> -->
				{:else}
					<div class="text-block-15">
						Get in touch : avatalk@groovworks.com<br />
					</div>
					<!-- <div class="footer_con_term">
                    <p class="paragraph-15-avatalk">
                        <a href="https://phantom-cap-f7c.notion.site/d58aaaedee164364a7a74eb98181d036" target="_blank" class="link-19 avatalk">Terms and Conditions</a> | 
                        <a href="https://phantom-cap-f7c.notion.site/7ccdf3b4e75b412a89a76a3daaa76509" target="_blank" class="link-19 avatalk">Privacy Policy</a> | 
                        <a href="https://phantom-cap-f7c.notion.site/36d49e46c40d4566aa868f710990bb57" target="_blank" class="link-19 avatalk">Marketing Usage</a>
                    </p>
                </div> -->
				{/if}
				<div class="footer_con_term">
					<p class="paragraph-15-avatalk">
						<a
							href={$_("project.index.49_1")}
							target="_blank"
							class="link-19 avatalk">{$_("project.index.49")}</a
						>
						|
						<a
							href={$_("project.index.50_1")}
							target="_blank"
							class="link-19 avatalk">{$_("project.index.50")}</a
						>
						|
						<a
							href={$_("project.index.51_1")}
							target="_blank"
							class="link-19 avatalk">{$_("project.index.51")}</a
						>
					</p>
				</div>
				<div class="text-block-15">
					Copyright © Groovworks Inc. All Rights Reserved.
				</div>
			</div>
		</div>
	</div>
</div>

<style>
	.wrap {
		overflow: auto;
		position: initial;
	}

	/* auth 페이지 레이아웃 고정 */
	:global(#index-layout .container) {
		padding-top: 92px !important;
		height: auto !important;
		min-height: 100vh;
	}
	:global(#index-layout .inner) {
		height: auto !important;
		min-height: unset !important;
		align-items: flex-start !important;
	}
	:global(#index-layout .join-membership) {
		height: auto !important;
		min-height: unset !important;
	}
	@media screen and (max-width: 768px) {
		:global(#index-layout .container) {
			padding-top: 64px !important;
		}
	}
	.footer_con_term {
		text-align: center;
	}
	.footer_con {
		margin-top: 26px;
	}
	.home-icon {
		margin-left: 20px;
		display: inline-flex;
		align-items: center;
		color: #364862;
		cursor: pointer;
		transition: opacity 0.15s;
		/* 웹플로우 전역 .home-icon 의 배경 홈 아이콘 제거 (인라인 SVG 와 겹침 방지) */
		background-image: none;
		width: auto;
		height: auto;
	}
	.home-icon:hover {
		opacity: 0.6;
	}
	.home-icon svg {
		width: 26px;
		height: 26px;
		display: block;
	}
	.idx-nav.dark .home-icon {
		color: #fff;
	}

	/* ── Pill Nav ── */
	.nav-wrap {
		position: fixed;
		top: 20px;
		left: 0;
		right: 0;
		z-index: 200;
		display: flex;
		justify-content: center;
		pointer-events: none;
	}
	.idx-nav {
		width: calc(100% - 96px);
		max-width: 1824px;
		background: rgba(255, 255, 255, 0.8);
		backdrop-filter: blur(14px);
		-webkit-backdrop-filter: blur(14px);
		border-radius: 30px;
		box-shadow:
			0 4px 6px -4px rgba(173, 70, 255, 0.05),
			0 10px 15px -3px rgba(173, 70, 255, 0.05);
		pointer-events: all;
		transition: box-shadow 0.2s;
	}
	.idx-nav.scrolled {
		box-shadow:
			0 4px 6px -4px rgba(173, 70, 255, 0.12),
			0 10px 20px -3px rgba(173, 70, 255, 0.1);
	}
	.nav-inner {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 33px;
		height: 72px;
	}
	.nav-left {
		display: flex;
		align-items: center;
		gap: 48px;
	}
	.nav-logo {
		height: 22px;
		width: auto;
		object-fit: contain;
	}
	.nav-links {
		display: flex;
		gap: 28px;
	}
	.nl {
		font-size: 16px;
		font-weight: 500;
		color: #364862;
		text-decoration: none;
		transition: opacity 0.15s;
	}
	.nl:hover {
		opacity: 0.6;
	}
	.nl-active {
		font-weight: 700;
	}
	.nav-right {
		display: flex;
		align-items: center;
		gap: 10px;
	}
	.language-sel {
		color: black;
	}
	.btn-login {
		font-size: 16px;
		font-weight: 600;
		color: #616161;
		background: rgba(242, 242, 242, 1);
		border-radius: 10px;
		padding: 6px 20px;
		height: 40px;
		border: none;
		cursor: pointer;
		font-family: inherit;
		transition: opacity 0.15s;
	}
	.btn-login:hover {
		opacity: 0.75;
	}
	.btn-start {
		font-size: 16px;
		font-weight: 600;
		color: #fff;
		background: #242428;
		border-radius: 10px;
		padding: 6px 20px;
		height: 40px;
		border: none;
		cursor: pointer;
		font-family: inherit;
		transition: opacity 0.15s;
	}
	.btn-start:hover {
		opacity: 0.8;
	}

	/* ── Dark nav (character-chat) ── */
	.idx-nav.dark {
		background: rgba(20, 20, 28, 0.82);
		box-shadow:
			0 4px 6px -4px rgba(0, 0, 0, 0.3),
			0 10px 15px -3px rgba(0, 0, 0, 0.2);
	}
	.idx-nav.dark.scrolled {
		box-shadow:
			0 4px 6px -4px rgba(0, 0, 0, 0.4),
			0 10px 20px -3px rgba(0, 0, 0, 0.3);
	}
	.idx-nav.dark .nav-logo {
		filter: brightness(0) invert(1);
	}
	.idx-nav.dark .nl {
		color: rgba(255, 255, 255, 0.8);
	}
	.idx-nav.dark .nl-active {
		color: #fff;
	}
	.idx-nav.dark .btn-login {
		background: rgba(255, 255, 255, 0.12);
		color: #fff;
	}
	.idx-nav.dark .btn-start {
		background: #fff;
		color: #242428;
	}

	@media screen and (max-width: 1024px) {
		.idx-nav {
			width: calc(100% - 48px);
		}
		.nav-inner {
			padding: 0 24px;
			height: 60px;
		}
		.nav-links {
			gap: 16px;
		}
	}
	/* ── Hamburger ── */
	.hamburger {
		display: none;
		flex-direction: column;
		justify-content: center;
		gap: 4px;
		width: 28px;
		height: 28px;
		background: none;
		border: none;
		cursor: pointer;
		padding: 2px;
		flex-shrink: 0;
	}
	.hamburger span {
		display: block;
		width: 18px;
		height: 1.5px;
		background: #364862;
		border-radius: 2px;
		transition: transform 0.2s, opacity 0.2s;
	}
	.hamburger.open span:nth-child(1) { transform: translateY(5.5px) rotate(45deg); }
	.hamburger.open span:nth-child(2) { opacity: 0; }
	.hamburger.open span:nth-child(3) { transform: translateY(-5.5px) rotate(-45deg); }

	.idx-nav.dark .hamburger span { background: #fff; }

	/* ── Mobile menu ── */
	.mobile-menu {
		position: absolute;
		top: calc(100% + 8px);
		left: 0;
		right: 0;
		background: rgba(255, 255, 255, 0.95);
		backdrop-filter: blur(14px);
		-webkit-backdrop-filter: blur(14px);
		border-radius: 20px;
		padding: 16px;
		display: flex;
		flex-direction: column;
		gap: 4px;
		box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
		pointer-events: all;
		z-index: 10;
	}
	.mobile-menu.dark {
		background: rgba(20, 20, 28, 0.95);
	}
	.mm-link {
		margin: 0;
		font-size: 16px;
		font-weight: 500;
		color: #364862;
		text-decoration: none;
		padding: 12px 16px;
		border-radius: 12px;
		transition: background 0.15s;
		box-sizing: border-box;
		display: block;
		width: 100%;
	}
	.mm-link:hover { background: rgba(0, 0, 0, 0.05); }
	.mm-active { font-weight: 700; }
	.mobile-menu.dark .mm-active { color: #fff; }
	.mobile-menu.dark .mm-link { color: rgba(255, 255, 255, 0.85); }
	.mobile-menu.dark .mm-link:hover { background: rgba(255, 255, 255, 0.08); }
	.mm-divider {
		height: 1px;
		background: rgba(0, 0, 0, 0.08);
		margin: 4px 0;
	}
	.mobile-menu.dark .mm-divider { background: rgba(255, 255, 255, 0.1); }
	.mm-btn-login {
		margin: 0;
		font-size: 15px;
		font-weight: 600;
		color: #616161;
		background: rgba(242, 242, 242, 1);
		border-radius: 10px;
		padding: 12px 16px;
		border: none;
		cursor: pointer;
		font-family: inherit;
		text-align: left;
		box-sizing: border-box;
		width: 100%;
		display: block;
	}
	.mm-btn-start {
		margin: 0;
		font-size: 15px;
		font-weight: 600;
		color: #fff;
		background: #242428;
		border-radius: 10px;
		padding: 12px 16px;
		border: none;
		cursor: pointer;
		font-family: inherit;
		text-align: left;
		box-sizing: border-box;
		width: 100%;
		display: block;
	}
	.mobile-menu.dark .mm-btn-login {
		background: rgba(255, 255, 255, 0.12);
		color: #fff;
	}
	.mobile-menu.dark .mm-btn-start {
		background: #fff;
		color: #242428;
	}

	@media screen and (max-width: 768px) {
		.nav-links {
			display: none;
		}
		.desktop-only {
			display: none;
		}
		.hamburger {
			display: flex;
		}
		.nav-wrap {
			top: 12px;
		}
		.idx-nav {
			width: calc(100% - 24px);
		}
		.nav-inner {
			height: 52px;
		}
	}
</style>
